module.exports = __webpack_public_path__ + "static/media/yuan3.2a412287.png";